import { RTNode, RTParagraphNode } from '@prismicio/types';

export const getTextFromRichTextField = (textField: RTNode | undefined): string => {
    if (!textField) return '';
    return (textField as RTParagraphNode).text;
};
